import dynamic from 'next/dynamic';
import { UpsellProps } from './Upsell.types';

export const Upsell = dynamic<UpsellProps>(() => import('./Upsell').then(module => module.Upsell));
